export default {
    computed: {
        getInventoryAdjustmentStatus () {
            return [
                { value: 0, label: this.$t('fbb.alloment.draft', { defaultValue: '草稿' }) },
                { value: 5, label: this.$t('fbb.inbound.check_pending', { defaultValue: '待审核' }) },
                { value: 10, label: this.$t('fbb.inventory.part_processing', { defaultValue: '部分处理' }) },
                { value: 70, label: this.$t('global.upload.complete', { defaultValue: '完成' }) }
            ];
        },
        getAdjustmentBusinessType () {
            return [{
                label: this.$t('bi.work.task_category_other', { defaultValue: '其他' }),
                value: 0,
            },  {
                label: this.$t('fbb.inventory.stock_init', { defaultValue: '库存初始化' }),
                value: 1,
            }, {
                label: this.$t('fbb.misc.send_back', { defaultValue: '借出还回' }),
                value: 2,
            }, {
                label: this.$t('fbb.misc.gift_received', { defaultValue: '赠品接收' }),
                value: 3,
            }, {
                label: this.$t('fbb.misc.inventory_check', { defaultValue: '库存盘点' }),
                value: 4,
            }, {
                label: this.$t('fbb.misc.diff_adjust', { defaultValue: '库存差异调整' }),
                value: 5,
            }, {
                label: this.$t('fbb.misc.common_adjust', { defaultValue: '一般入库接收调整' }),
                value: 6,
            }, {
                label: this.$t('fbb.misc.remove_warehouse', { defaultValue: '移库' }),
                value: 7,
            }, {
                label: this.$t('fbb.misc.remove_other', { defaultValue: '跨仓移库' }),
                value: 10,
            }]
        },
        operateTypeList(){
            return [{
                label: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
                value: 700
            }, {
                label: this.$t('global.common.finish', { defaultValue: '完成' }),
                value: 800,
            }, {
                label: this.$t('fbb.inbound.add_remark', { defaultValue: '添加备注' }),
                value: 910
            }]
        }
    }
}